/**
 * Punktzahl einer Partie: Amtszeit, Wahlergebnisse, Gesetze und Lage des Landes.
 * Liegt in der Engine, damit Client und Server (verify-run) dieselbe Formel nutzen.
 */
import type { GameState } from './types';

export function scoreRun(S: GameState): number {
  const legs = S.career.length;
  const shares = S.career.map((c) => c.s1 ?? c.s0);
  const avgShare = shares.length ? shares.reduce((a, b) => a + b, 0) / shares.length : 0;
  const laws = S.career.reduce((s, c) => s + c.laws, 0);
  const fiscal = Math.max(-30, Math.min(20, S.saldo || 0));
  const debt = Math.max(0, (S.debt || 2950) - 2950);
  const ind = S.ind || {}, ind0 = S.ind0 || {};
  const indicators = Object.keys(ind).reduce((s, k) => s + (ind[k] - (ind0[k] ?? ind[k])) / Math.max(1, Math.abs(ind0[k] ?? 1)) * 100, 0);
  return Math.max(0, Math.round(legs * 1000 + avgShare * 40 + laws * 25 + fiscal * 10 - debt * 0.5 + indicators * 2));
}

/** Zusammenfassung einer beendeten Partie für die Bestenliste. */
export function runSummary(S: GameState) {
  const last = S.career[S.career.length - 1];
  return {
    party_name: S.name,
    legislatures: S.career.length,
    final_share: last?.s1 ?? null,
    laws: S.career.reduce((s, c) => s + c.laws, 0),
    score: scoreRun(S),
    difficulty: S.cfg?.diff ?? 'normal',
    seed: S.seed ?? 0,
  };
}
